import React from 'react';
import { Loading } from 'components/loading/Loading';
import { useAppSelector } from 'ducks/hooks';
import { selectSettings } from 'ducks/settings/selectors';
import { selectAuthenticate } from 'ducks/user/selectors';
import { useSwitchTheme } from 'hooks/useSwitchTheme';
import { Warning } from 'layouts/Warning';
import { Modals } from 'modals';
import { shallowEqual } from 'react-redux';
import { Navigate, Outlet } from 'react-router';
import { useLocation } from 'react-router-dom';
import { routes } from 'routes';
import { Snackbar } from 'templates/components/Snackbar';

import cn from 'templates/Template.module.scss';

const { PROJECTS } = routes;

export const PublicTemplate = () => {
  const location = useLocation();
  const auth_check = useAppSelector(selectAuthenticate, shallowEqual);
  const settings = useAppSelector(selectSettings);

  const { theme } = useSwitchTheme();

  if (auth_check) {
    return <Navigate to={location.state?.referer || PROJECTS.path} />;
  }

  return (
    <div className={cn.public}>
      <Warning />
      <div className={cn.content} style={{ background: theme.background }}>
        <Outlet />
      </div>
      <Snackbar />
      <Modals />
      {settings.loading && <Loading variant="dark" />}
    </div>
  );
};
